// SR-CUSTOM: enforce and explain the stock ceiling on quantity fields.
//
// Three jobs:
//
// 1. SYNC (product pages only). Liquid renders the correct max on first
//    load, but the theme's variant switcher only swaps the inner HTML of a
//    few known regions (#price-, #Sku-, #Inventory-) — it does not re-render
//    the quantity input, so a variant change would leave the previous cap in
//    place. The inventory region IS re-rendered per variant, so the numbers
//    are carried there (data-sr-qty / data-sr-cap) and mirrored across.
//
// 2. CLAMP (everywhere). The product form is rendered with `novalidate` and
//    the cart updates over fetch, so the browser never enforces the max
//    attribute on its own.
//
// 3. EXPLAIN (everywhere). Clamping silently is its own problem: the theme
//    leaves the + button enabled at the ceiling and it simply does nothing,
//    which reads as broken. Both surfaces carry a hidden [data-sr-qty-limit]
//    notice and we reveal it on a blocked press or an over-typed number:
//      - in the cart, it sits under that line's quantity stepper
//      - on a product page, it temporarily replaces the stock status line
//        ([data-sr-status]) inside the inventory block, which keeps it out of
//        the Add-to-cart row and puts it where stock information already is
//    Dropping back below the ceiling restores the normal status line.
//
// Clamping is driven purely by the max attribute Liquid rendered, so inputs
// without a ceiling (continue-selling variants) are untouched.

(function () {
  if (window.__srQtyMax) return;
  window.__srQtyMax = true;

  function isProductQuantityInput(el) {
    if (!el || !el.classList || !el.classList.contains('quantity__input')) return false;
    if (el.type === 'hidden') return false;
    var formAttr = el.getAttribute('form') || '';
    if (formAttr.indexOf('product-form-') === 0) return true;
    return !!(el.closest && el.closest('product-form'));
  }

  function sync() {
    var holder = document.querySelector('[id^="Inventory-"] [data-sr-qty]');
    if (!holder) return;

    var inputs = Array.prototype.filter.call(
      document.querySelectorAll('.quantity__input'),
      isProductQuantityInput
    );
    if (!inputs.length) return;

    var qty = parseInt(holder.getAttribute('data-sr-qty'), 10);
    var shouldCap = holder.getAttribute('data-sr-cap') === 'true' && qty > 0;

    inputs.forEach(function (input) {
      if (shouldCap) {
        input.setAttribute('max', qty);
        input.dataset.max = qty;
        if (parseInt(input.value, 10) > qty) input.value = qty;
      } else {
        input.removeAttribute('max');
        delete input.dataset.max;
      }
    });
  }

  function flash(note) {
    note.style.transition = 'none';
    note.style.opacity = '0.25';
    void note.offsetWidth;
    note.style.transition = 'opacity .45s ease';
    note.style.opacity = '1';
  }

  // Show the ceiling notice for whichever surface this input belongs to.
  function announceLimit(input) {
    var cartLine = input.closest && input.closest('.cart-item');
    if (cartLine) {
      var lineNote = cartLine.querySelector('[data-sr-qty-limit]');
      if (!lineNote) return;
      lineNote.style.display = 'flex';
      flash(lineNote);
      return;
    }

    var region = document.querySelector('[id^="Inventory-"]');
    if (!region) return;
    var note = region.querySelector('[data-sr-qty-limit]');
    if (!note) return;
    var status = region.querySelector('[data-sr-status]');
    if (status) status.style.display = 'none';
    note.style.display = 'flex';
    flash(note);
  }

  // Back below the ceiling: put the normal stock line back.
  function restoreStatus(input) {
    if (input.closest && input.closest('.cart-item')) return;
    var region = document.querySelector('[id^="Inventory-"]');
    if (!region) return;
    var note = region.querySelector('[data-sr-qty-limit]');
    var status = region.querySelector('[data-sr-status]');
    if (note) note.style.display = 'none';
    if (status) status.style.display = 'flex';
  }

  function clamp(event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!max || isNaN(max)) return;

    var value = parseInt(input.value, 10);
    if (value > max) {
      input.value = max;
      announceLimit(input);
    } else if (value < max) {
      restoreStatus(input);
    }
  }

  // The + button stays enabled at the ceiling and quietly does nothing.
  // Catch the press itself so the customer gets an answer either way.
  function onPlus(event) {
    var button = event.target && event.target.closest && event.target.closest('[name="plus"]');
    if (!button) return;
    var wrapper = button.closest('quantity-input');
    if (!wrapper) return;
    var input = wrapper.querySelector('.quantity__input');
    if (!input) return;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!max || isNaN(max)) return;
    if (parseInt(input.value, 10) >= max) announceLimit(input);
  }

  function start() {
    sync();

    document.addEventListener('input', clamp, true);
    document.addEventListener('change', clamp, true);
    document.addEventListener('click', onPlus, true);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target && target.closest && target.closest('[id^="Inventory-"]')) {
          sync();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
